import { RocCalculator, RocCalculatorOutput } from '@lib/utils';

export function getGoalCalculatorOutput(rocCalculator: RocCalculator): RocCalculatorOutput {
  return {
    earningCumulativeProb25: rocCalculator.earningCumulativeProb25,
    earningCumulativeProb50: rocCalculator.earningCumulativeProb50,
    earningCumulativeProb75: rocCalculator.earningCumulativeProb75,
    federalLoanAveraged: rocCalculator.federalLoanAveraged,
    investment25: rocCalculator.investment25,
    investment75: rocCalculator.investment75,
    lifeAnnualizedRoc25: rocCalculator.lifeAnnualizedRoc25,
    lifeAnnualizedRoc75: rocCalculator.lifeAnnualizedRoc75,
    lifeRevenue25: rocCalculator.lifeRevenue25,
    lifeRevenue75: rocCalculator.lifeRevenue75,
    monthlyLoanPayment50: rocCalculator.monthlyLoanPayment50,
    monthlySalary25: rocCalculator.monthlySalary25,
    monthlySalary50: rocCalculator.monthlySalary50,
    monthlySalary75: rocCalculator.monthlySalary75,

    outOfPocket50: rocCalculator.outOfPocket50,
    privateLoanAveraged: rocCalculator.privateLoanAveraged,
    roc25: rocCalculator.roc25,

    roc75: rocCalculator.roc75,
    time: rocCalculator.time,

    yearsStudyForDegrees50: rocCalculator.yearsStudyForDegrees50,
    yearsToRocBreakEven25: rocCalculator.yearsToRocBreakEven25,
    yearsToRocBreakEven75: rocCalculator.yearsToRocBreakEven75,
    alumniLifetimeEarning: rocCalculator.alumniLifetimeEarning,
    alumniCumulativeEarnings: rocCalculator.alumniCumulativeEarnings,
    alumniMonthlySalaries: rocCalculator.alumniMonthlySalaries
  };
}
